export const sponsorFormatPrice = (num: number) => {
    const million = Math.floor(num / 1000000);
    const thousand = Math.floor((num % 1000000) / 1000);
    const rest = num % 1000;
    const millionStr = million > 0 ? `${million} میلیون${thousand > 0 ? ' و' : ' تومان'}` : '';
    const thousandStr = thousand > 0 ? `${thousand > 1 ? thousand : ''} هزار تومان` : '';
    const restStr = rest > 0 ? `${rest}` : '';
    return [millionStr, thousandStr, restStr].filter(Boolean).join(' ');
}
export const sponsorFormatNumber = (num: number) => {
    const million = Math.floor(num / 1000000);
    const thousand = Math.floor((num % 1000000) / 1000);
    const rest = num % 1000;
    const millionStr = million > 0 ? `${million} میلیون${thousand > 0 ? ' و' : ''}` : '';
    const thousandStr = thousand > 0 ? `${thousand > 1 ? thousand : ''} هزار` : '';
    const restStr = rest > 0 ? `${rest}` : '';
    return [millionStr, thousandStr, restStr].filter(Boolean).join(' ');
}